export const EVENT_PILL_HEIGHT = 26; // 21 + 5 margin bottom
export const COLLAPSED_HEADER_HEIGHT = 24;
export const EXPANDED_HEADER_HEIGHT = 57;
export const MAX_EVENTS_EXPANDED = 10; // show scrollbar if more than 10 events & expanded
export const TRANSITION_DURATION = 300;
export const WIDTH_EXPANSION = 60;
